// * Logo image - robot sur anvil
export function Logo({ className = "w-12 h-12" }: { className?: string }) {
  return (
    <img
      src="/logo.jpg"
      alt="AgentTeamForge Logo"
      className={`${className} object-contain login-logo`}
    />
  )
}

